import API from "@irati/utils/services/API"
import {sortBy, reverse} from "lodash"
import endpoints from "../endpoints"

/**
 * Accepts a tenant name and returns the
 *
 * @param tenant
 * @returns {PromiseLike<T> | Promise<T>}
 */
export const fetchAllSurveys = (tenant, scheduleId) => {
  const options = {params: {scheduleId}}
  return API.get(endpoints.surveys(tenant), options).then((response) => {
    return reverse(sortBy(response.data.data, ["createdAt"]))
  })
}

/**
 * Creates a new survey
 *
 * @param survey
 * @returns {PromiseLike<T> | Promise<T>}
 */
export const createSurvey = (survey) => {
  const {tenant, ...formattedSurvey} = survey
  return API.post(endpoints.surveys(tenant), formattedSurvey).then((response) => response.data)
}

/**
 * Get an existing survey
 *
 * @param surveyId
 * @returns {PromiseLike<T> | Promise<T>}
 */
export const fetchSurvey = (tenant, id) => {
  return API.get(endpoints.survey(tenant, id)).then((response) => response.data)
}

/**
 * Update survey
 *
 * @param surveyId
 * @returns {PromiseLike<T> | Promise<T>}
 */
export const updateSurvey = (survey) => {
  /** @todo  manually format survey object here, but prob write a formatter later */
  const {createdAt, scheduleId, test, openedAt, closeAt, id, tenant, ...formattedSurvey} = survey
  return API.put(endpoints.survey(tenant, id), formattedSurvey, survey.Etag).then((response) => response.data)
}

/**
 * Get survey info by surveyId
 *
 * @param surveyId
 * @returns {Promise<T> | Promise<*> | * | PromiseLike<T>}
 */
export const getSurveyInfo = (tenant, surveyId) => {
  return API.get(endpoints.surveyInfo(tenant, surveyId), {unAuth: true}).then((response) => response.data)
}
